import { take, fork, select, call } from 'redux-saga/effects';

import {
    AUTH_LOGOUT_SUCCESS,
    AUTH_INIT_SUCCESS,
    AUTH_INIT_FAIL,
} from 'yeself-client-common/security/types';

import { respawn } from 'yeself-client-common/utils/SagaUtils';

import { selectUserEmail } from 'Console/data/security/selectors';

function* setSegmentationUserTask() {
    if (window.yesElf) {
        const username = yield select(selectUserEmail);
        yield call([window, 'yesElf'], 'segmentation', 'userId', username);
    }
}

function* unsetSegmentationUserTask() {
    if (window.yesElf) {
        yield call([window, 'yesElf'], 'segmentation', 'userId', null);
    }
}

function* authSuccessWatcher() {
    while (true) {
        yield take(AUTH_INIT_SUCCESS);
        yield fork(setSegmentationUserTask);
    }
}

function* authFailWatcher() {
    while (true) {
        yield take([AUTH_INIT_FAIL, AUTH_LOGOUT_SUCCESS]);
        yield fork(unsetSegmentationUserTask);
    }
}

function* YesElfIntegrationSaga() {
    yield respawn(authSuccessWatcher);
    yield respawn(authFailWatcher);
}

export default YesElfIntegrationSaga;
